"use strict";

import _ from "lodash";
import classNames from "classnames";
import React, { Component, PropTypes } from "react";

const isObject = _.isObject;
const findWhere = _.find;
const reduce = _.reduce;
const startsWith = _.startsWith;
const memoize = _.memoize;
const trim = _.trim;
const some = _.some;

import InputComponentBase from ".\\InputComponentBase";
import countryData from ".\\country_data";

/******************************************************************************
** PhoneInput
*/

Array.prototype.selectMany = function (selector) {
	return this.map(selector).reduce(function (a, b) {
		return a.concat(b);
	});
};

export default class PhoneInput extends InputComponentBase {

	// memoize results based on the first 5/6 characters. That is all that matters
	static guessSelectedCountry(phoneNumber, defaultCountryIso2Code) {
		let fn = memoize(function(inputNumber) {
			let bestGuess;
			let secondBestGuess = findWhere(countryData.allCountries, { iso2: defaultCountryIso2Code }) || countryData.allCountries[0];
			if (trim(inputNumber) !== '') {
				let reducedCountries = reduce(countryData.allCountries, function(result, country) {
					if (startsWith(inputNumber, country.dialCode)) {
						result.push(country);
					}
					return result;
				}, []);
				reducedCountries = reducedCountries.selectMany(function(country) {
					let a = [{ dialCode: country.dialCode, priority: country.priority, country: country }];
					if (country.hasAreaCodes) {
						a = a.concat(country.areaCodes.map(function(areaCode) {
							return { dialCode: country.dialCode + areaCode, priority: country.priority, country: country }
						}));
					}
					return a;
				});
				bestGuess = reduce(reducedCountries, function(selectedPair, pair) {
					if (startsWith(inputNumber, pair.dialCode)) {
						if (pair.dialCode.length > selectedPair.dialCode.length) {
							return pair;
						}
						if (pair.dialCode.length === selectedPair.dialCode.length && pair.priority < selectedPair.priority) {
							return pair;
						}
					}

					return selectedPair;
				}, { dialCode: '', priority: 10001 }, this);
			} else {
				return secondBestGuess;
			}

			if (!bestGuess.country) {
				return secondBestGuess;
			}

			return bestGuess.country;
		});
		let result = fn(phoneNumber);
		return result;
	}

	static getCountryByCode(iso2) {
		const countryIndex = countryData.allCountriesIso2Lookup[iso2];
		return countryData.allCountries[countryIndex];
	}

	constructor(props) {
		super(props);
		this._dispatch = this._dispatch.bind(this);
		let defaultCountryIso2Code = props.context.getFormState().currentCountryIso2Code.toLowerCase();
		if (props.defaultValue) {
			let country = PhoneInput.guessSelectedCountry(props.defaultValue, defaultCountryIso2Code);
			if (country) {
				defaultCountryIso2Code = country.iso2;
			}
		}
		let defaultCountry = PhoneInput.getCountryByCode(defaultCountryIso2Code);
		//console.log(defaultCountryIso2Code, defaultCountry);
		this.state = Object.assign(this.state || {}, {
			defaultCountryIso2Code: defaultCountryIso2Code,
			defaultCountry: defaultCountry,
			defaultValue: props.defaultValue || ("+" + (defaultCountry ? defaultCountry.dialCode : ""))
		});
	}

	componentWillMount() {
		if (typeof super.componentWillMount == "function")
			super.componentWillMount();
		this.props.context.dispatcher.register(this._dispatch);
	}

	componentWillUnmount() {
		if (typeof super.componentWillUnmount == "function")
			super.componentWillUnmount();
		this.props.context.dispatcher.unregister(this._dispatch);
	}

	_dispatch(payload) {
		switch (payload.actionType) {
			case "country-update":
				if (this.isInputEmpty()) {
					let countryIsoCode = payload.selectedCountry.toLowerCase();
					let country = PhoneInput.getCountryByCode(countryIsoCode);
					const number = "+" + country.dialCode;
					this.setState({
						defaultCountryIso2Code: countryIsoCode,
						defaultCountry: country,
						defaultValue: number
					});
					let userInput = this._getUserInput();
					if (userInput) {
						userInput.value = number;
					}
				}
				//console.log(`country update: ${payload.selectedCountry}`);
				break;
		}
	}

	isInputEmpty() {
		let userInput = this._getUserInput();
		if (!userInput) return true;
		let formattedNumber = userInput.value;
		const number = formattedNumber.replace(/^[\+]/g, "");
		let hasUserInput = number.length > 0
			&& (number.length > this.state.defaultCountry.dialCode.length || !this.state.defaultCountry.dialCode.startsWith(number));
		return !hasUserInput;
	}

	renderEditor(placeholderText) {
		let cssClassNames = classNames(this.props.inputClassNames, this.state.defaultCountryIso2Code);
		return (
				<input ref="input" type="text" name={this.props.name} defaultValue={this.state.defaultValue}
				className="input-field__input input-field__input_is-number" id={this.state.clientId} placeholder={placeholderText}
						onFocus={this._onFocus} onBlur={this._onBlur}
						onChange={this._onChange} onInput={this._onInput} onSubmit={this._onSubmit}
						onKeyPress={::this._onKeyPress}
						/>
			);
	}

	_onChange() {
		let formattedNumber = this.refs.input.value;
		if (!formattedNumber.startsWith("+")) {
			this.refs.input.value = "+" + this.state.defaultCountry.dialCode + formattedNumber;
		}
		super._onChange();
	}

	_onKeyPress(e) {
		let regExp = /[0-9\+\-\s]/g;
		if (!regExp.test(e.key)) {
			e.preventDefault();
		}
	}

}



/** WEBPACK FOOTER **
 ** ./forms/PhoneInput.jsx
 **/